import {Route, Redirect} from 'react-router-dom';
import React from 'react';
import {inject, observer} from 'mobx-react';

const PrivateRoute = ({component: Component, store, ...rest}) => (
  <Route
    {...rest}
    render={(props) =>
      store.auth.authenticated ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/auth/login',
            state: {from: props.location}
          }}
        />
      )
    }
  />
);

export default inject('store')(observer(PrivateRoute));
